import React from "react";

interface ClockIconProps {
  color?: string;
  className?: string;
}

const ClockIcon: React.FC<ClockIconProps> = ({
  color = "#4B5563",
  className,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
    >
      <circle
        cx="8"
        cy="8"
        r="6"
        stroke={color}
        strokeWidth="1.5"
        fill="none"
      />
      <path
        d="M8 5V8L10 10"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ClockIcon;
